enum CustomerModuleApiSuffixModels {
  INDUSTRYTYPE = 'industrycategories',
  Industry = 'industries',
  Industry_CATEGORY_DROPDOWN = 'ux/industrycategories',
  Customer = 'customers',
  SOURCE = 'sources',
  CUSTOMER_BASICINFO = 'customers/basic-detail',
  CUSTOMER_STATUS = 'ux/customer-status',
  DECODER_CONFIGS = 'decoder-configs',
  SPECIAL_ALARM_TAGGING = 'special-alarm-tagging',
  CUSTOMER_ZONES = 'zones',
  ZONE_LIST = 'ux/zones',
  EQUIPMENT = 'ux/items',
  UX_CUSTOMR_KEYHOLDERS = 'ux/customer/keyholders',
  UX_CUSTOMR_KEYHOLDERS_WITH_CUSTOMER_ID = 'ux/customer-keyholders',
  KEYHOLDER_DETAILS = 'customer/keyholders/details',
  KEYHOLDERS = 'customer/keyholders',
  SPECIAL_INSTRUCTIONS = 'customer/special-instructions',
  ARMING_AND_DISARMING = 'customer/arming-and-disarming',
  ACCESS_TO_PREMISES = 'customers/access-to-premises',
  SERVICE_SITE_HAZARD = 'customer/service-site-hazard',
  DOMESTIC_WORKERS_DETAILS = 'domestic-workers/domestic/details',
  DOMESTIC_WORKERS = 'domestic-workers',
  EMERGENCY_CONTACTS = 'emergency-contacts',
  DOG_TYPES = 'dog-types',
  MEDICAL_CONDITIONS = 'customer/special-instructions/medical-conditions',
  DIGIPAD = 'customers/access-to-premises/digipad',
  LOCKBOX = 'customers/access-to-premises/lockbox',
  AGREEMENT_TABS = 'customer-agreement/tabs',
  SEARCH_CUSTOMER_ADDRESS = 'search/customers/address',
  UX_DEBTORS = 'ux/debtors',
  DEBTOR_BANKING_COUNTER_SALES ="debtor-banking-counter-sale",
  RATE_OUR_SERVICE_CALL_FOLLOWUP = 'rate-our-service-call-followup',
  RATE_OUR_SERVICE_CALL_FOLLOWUP_STATUS = 'ux/rate-our-service-call-followup-status',
  RATE_OUR_SERVICE_CALL_RATING = 'rate-our-service-call-rating',
  HOLIDAY_INSTRUCTION_LIST = 'holiday-instruction-list',
  HOLIDAY_INSTRUCTION_DETAILS = 'holiday-instruction-details',
  HOLIDAY_INSTRUCTION_CANCEL = 'holiday-instruction-cancel',
  HOLIDAY_INSTRUCTION = 'holiday-instructions',
  HOLIDAY_INSTRUCTION_CONTACTS = 'holiday-instruction-contacts',
  HOLIDAY_INSTRUCTION_EMERGENCY_CONTACTS = 'holiday-instruction-emergency-contacts',
  CUSTOMER_VERIFICATION_PASSWORD = 'customer-verification/Password',
  CUSTOMER_VERIFICATION_ID_NUMBER = 'customer-verification/id-number',
  CUSTOMER_VERIFICATION_EMAIL = 'customer-verification/email-address',
  CUSTOMER_VERIFICATION_COMPANY_REGISTRATION = 'customer-verification/company-registration-number',
  CUSTOMER_VERIFICATION_COMPANY_PASSPORT_NUMBER = 'customer-verification/passport-number',
  CUSTOMER_VERIFICATION_BANK_NAME = 'customer-verification/bank-name',
  CUSTOMER_VERIFICATION_ACCOUNT_TYPE = 'customer-verification/account-type',
  CUSTOMER_VERIFICATION_POSTAL_ADDRESS = 'customer-verification/postal-address',
  CUSTOMER_VERIFICATION_VAT_NUMBER = 'customer-verification/vat-number',
  CUSTOMER_VERIFICATION_OTP = 'customer-verification/otp',
  CUSTOMER_VERIFICATION_CONTACT_INFO = 'customer-verification/contact-info',
  CUSTOMER_VERIFICATION_CANCEL_VERIFICATION = 'customer-verification/cancel-verification',
  CUSTOMER_VERIFICATION_SEND_OTP = 'customer-verification/send-otp',
  CUSTOMER_VERIFICATION_VERIFY_OTP = 'customer-verification/verify-otp',
  CUSTOMER_VERIFICATION_CHECK = "customer-verification/check",
  BILL_OF_SERVICE_CONTRACTS = 'bill-of-service/contracts',
  SUBSCRIPTION_STOCK_DETAILS = 'subscription/stock-details',
  BILL_OF_SERVICE_DEBTOR_SERVICE = 'bill-of-service/debtor-and-service',
  BILL_OF_SERVICE_STOCK_DETAILS = 'bill-of-service/stock-details',
  CUSTOMERS_CPA_EXEMPT = 'customers/cpa-exempt',
  RISK_WATCH_AVAILABILITY = 'risk-watch/availability',
  RISK_WATCH_RETAINER_DETAILS = 'risk-watch/retainer-details',
  RISK_WATCH_GUARD_REQUEST_HISTORY = 'guard-request-history',
  RISK_WATCH = 'risk-watch',
  RISK_WATCH_GUARD = 'risk-watch-guard',
  RISK_WATCH_CANCEL = 'risk-watch-cancel',
  SHIFT_CANCEL_REASON = 'shift-cancel-reason',
  UX_SHIFT_CANCEL_REASON = 'ux/shiftcancel-reason-type',
  GUARD_REQUEST_DASHBOARD = 'guard-request',
  GUARD_REQUEST_PROCESS = 'guard-request-process',
  GUARD_REQUEST_CONFIRM = 'guard-request-confirm',
  SAFE_ENTRY_REQUEST = 'safe-entry-availability',
  SAFE_ENTRY_POST = "safe-entry",
  SAFE_ENTRY_PREMISES_TYPES = 'ux/safety-premises-types',
  KEYHOLDER_DETAILS_LIST = 'ux/customer-keyholders',
  SAFE_ENTRY_CANCEL = 'safe-entry-cancel',
  SAFE_ENTRY_RESHEDULE = 'safe-entry-reschedule',
  CUSTOMER_DEBTORS = 'customer-debtors/address',
  UX_CUSTOMER_DEBTORS = 'ux/customer-debtors',
  UX_DEALER_CUSTOMER_DEBTORS = 'ux/dealer-customer-debtors',
  GUARD_REQUEST_REPORT = 'guard-request-report',
  RISK_WATCH_SERVICE_MAPPING = 'risk-watch-service-mapping',
  CASUAL_GUARDING_SERVICE_PROCESS ='casual-guarding-service-process',
  CASUAL_GUARDING_SERVICE_CONFIRM = 'casual-guarding-service-confirm',

  /// non customer profile
  NON_CUSTOMER_CAMERA_PROFILE = 'camera-profile/non-customers',
  CAMERA_PROFILE = 'camera-profile',
  CAMERA_PROFILE_INFO = 'camera-profile/camera-info',
  CAMERA_PROFILE_DETAIL = 'camera-profile/detail',
  CAMERA_PROFILE_DEBTOR_DETAIL = 'camera-profile/debtor-detail',
  CAMERA_PROFILE_DEBTOR = 'camera-profile/debtor',
  CAMERA_PROFILE_DEBTOR_BANKING = 'camera-profile/debtor-banking',
  WHATSAPP_PROFILE = 'whatsapp-profile',
  WHATSAPP_PROFILE_DETAIL = 'whatsapp-profile/detail',
  EXECU_GUARD_PROFILE_CUSTOMER = 'execu-guard-profile/customer',
  NON_CUSTOMER_DEBTOR_SEARCH = 'non-customer-debtors/search',
  UX_MAIN_AREA = 'ux/main-areas',
  UX_SUB_AREA = 'ux/sub-areas',
  RECENT_CUSTOMER_TICKETS = 'customer/tickets',
  COMMUNITY_PROFILE = 'community-profile',
  COMMUNITY_PROFILE_DETAIL = 'community-profile/detail',

  COMMUNITY_CDM = 'community-cdm',
  COMMUNITY_CDM_DETAIL = 'community-cdm/detail',
  COMMUNITY_PROFILE_MANAGER_DETAIL = 'community-profile-manager/detail',
  COMMUNITY_PROFILE_MANAGER = 'community-profile-manager',

  NON_CLIENT_PROFILE_CUSTOMER = 'non-client-profile/non-client-customers',
  NON_CLIENT_PROFILE_DEBTOR = 'non-client-profile/debtor',
  NON_CLIENT_PROFILE_DEBTOR_BANKING = 'non-client-profile/debtor-banking',
  NON_CLIENT_PROFILE = 'non-client-profile',
  NON_CLIENT_PROFILE_DETAIL = 'non-client-profile/detail',
  NON_CLIENT_PROFILE_DEBTOR_DETAIL = 'non-client-profile/debtor-detail',

  HUB_PROFILE = 'hub-profile',
  HUB_PROFILE_DEBTOR = 'hub-profile/debtor',
  HUB_PROFILE_DEBTOR_BANKING = 'hub-profile/debtor-banking',
  HUB_PROFILE_DETAIL_LIST = 'hub-profile/non-customers',
  HUB_PROFILE_DETAILS = 'hub-profile/detail',
  HUB_PROFILE_DEBTOR_DETAILS = 'hub-profile/debtor-detail',
  NON_CUSTOMER_DEBTOR_BANKING_DETAIL = 'non-customer-debtors/debtor-banking',

  REPEATER_PROFILE = 'repeater-profile',
  REPEATER_PROFILE_KEY_HOLDER = 'repeater-profile/key-holder',
  REPEATER_PROFILE_EMERGENCY_CONTACTS = 'repeater-profile/emergency-contacts',
  REPEATER_PROFILE_KEY_HOLDER_DETAIL = 'repeater-profile/keyholder-detail',
  REPEATER_PROFILE_SPECIAL_INSTRUCTIONS = 'repeater-profile/special-instructions',
  REPEATER_PROFILE_SPECIAL_INSTRUCTIONS_DETAIL = 'repeater-profile/special-instructions/detail',
  REPEATER_PROFILE_LIST = 'repeater-profile/non-customers',
  REPEATER_PROFILE_DETAIL = 'repeater-profile/detail',

  DEBTOR_AVS_SCORE = 'debtor-avs/score',
  CUSTOMER_INSTALLATION_SITE_HAZARD = 'customer/installation-site-hazard',
  SAVE_OFFER = 'save-offer',
  SAVE_OFFER_DETAILS = 'save-offer-details',
  SAVE_OFFER_SERVICE_DETAILS = 'save-offer/service-details',
  SAVE_OFFER_DOA_LEVEL_CONFIG = 'save-offer-doa-level-config',
  SAVE_OFFER_DOA_LIMIT_CONFIG = 'save-offer-doa-limit-config',
  SAVE_OFFER_DOA_LIMIT_CONFIG_DETAIL = 'save-offer-doa-limit-config-detail',
  SAVE_OFFER_APPROVAL_DASHBOARD = 'save-offer/approval-dashboard',
  SAVE_OFFER_DOA_APPROVAL_UPDATE = 'save-offer/doa-approval-update',
  VALIDATE_SAVE_OFFER_EXIST = 'validate/save-offer-exist',

  // Debtor API's
  DEALER_DEBTORS = 'dealer-debtors',
  DEALER_DEBTORS_BANKING = 'debtor-banking-dealers',
  CREDIT_VETTING_DEALERS = 'credit-vetting-dealers',
  CREDIT_VETTING_DEALERS_SCORE = 'credit-vetting-dealers/score',
  CREDIT_VETTING_DEALERS_PROOF_OF_DOCUMENT = 'credit-vetting-dealers/proof-of-documents',

  NO_COST_SAVE_OFFER = 'nocost-saveoffer-reason',
  UX_NO_COST_SAVE_OFFER = 'ux/nocost-saveoffer-reason',
  NO_COST_SAVE_OFFER_DETAILS = 'nocost-saveoffer-reason/details',
  EXECU_GUARD_PROFILE = 'execu-guard-profile',
  EXECU_GUARD_PROFILE_DETAILS = 'execu-guard-profile/customer-detail',
  EXECU_GUARD_PROFILE_SERVICES = 'execu-guard-profile/services',
  EXECU_GUARD_PROFILE_CLASSIFICATION = 'execu-guard-profile/classification',
  EXECU_GUARD_PROFILE_CLASSIFICATION_DETAIL = 'execu-guard-profile/classification/detail',
  EXECU_GUARD_PROFILE_DEBATOR = 'non-customer-debtors',
  EXECU_GUARD_PROFILE_DEBATOR_DETAILS = 'non-customer-debtors/debtor-detail',
  EXECU_GUARD_DEBTOR_BANKING = 'non-customer-debtor-banking',
  EXECU_GUARD_PROFILE_ACCOUNT_NUMBER = 'execu-guard-profile/account-number',
  UX_ACCESS_TYPE = 'ux/access-type',
  TEST_PROFILE_CUSTOMER = 'test-profile/customer',
  TEST_PROFILE = 'test-profile',

  CASUAL_GUARDING_PROFILE = "casual-guarding-profile",
  CASUAL_GUARDING_PROFILE_STORE = "casual-guarding-profile/customer",

  ADT_SITE_PROFILE = 'adt-site-profile',
  ADT_SITE_PROFILE_STORE = 'adt-site-profile/customer',
  ADT_SITE_PROFILE_STORE_DETAIL = 'adt-site-profile/customer-detail',

  NKA_CUSTOMER_PROFILE_STORE = 'nka-customer-profile/customer',
  NKA_CUSTOMER_PROFILE = 'nka-customer-profile',
  NKA_CUSTOMER_PROFILE_DETAIL = 'nka-customer-profile/customer-detail',

  NON_CUSTOMER_ARMING_DISARMING = 'non-customer/arming-and-disarming',
  NON_CUSTOMER_ARMING_DISARMING_DETAIL = 'non-customer/arming-and-disarming/detail',
  NON_CUSTOMER_ACCESS_TO_PREMISES = "non-customers/access-to-premises",
  NON_CUSTOMER_ACCESS_TO_PREMISES_DETAIL = "/non-customers/access-to-premises/detail",
  NON_CUSTOMER_DEBTOR_INFORMATION = 'non-customer-debtors',
  NON_CUSTOMER_DEBTOR_INFORMATION_DETAIL = 'non-customer-debtors/debtor-detail',


  NON_CUSTOMER_DEBTOR_BANKING = 'non-customer-debtor-banking',
  NON_CUSTOMER_BUSINESS_CLASSIFICATON = 'business-classification',
  NON_CUSTOMER_BUSINESS_CLASSIFICATON_DETAIL = 'business-classification/detail',

  CUSTOMER_TICKET_NOTES_VERIFICATION = 'customer-ticket-notes-and-verification',
  SUSPENDED_ACCOUNT = 'suspended-account',
  SUSPENDED_ACCOUNT_DETAIL = '/suspended-account/detail',
  SUSPENDED_ACCOUNT_MAPPING = 'suspended-account-mapping',
  SUSPENDED_ACCOUNT_MAPPING_DETAIL = 'suspended-account-mapping/detail',
  UX_SUSPENDED_CUSTOMER = 'ux/suspended-customer',
  UX_SUSPENDED_DEBTOR = 'ux/suspended-debtor',
  UX_SUSPENDED_FINANCIAL_YEAR = 'ux/financial-year',
  SUSPENDED_ACCOUNT_CUSTOMER_DEBTOR = 'suspended-account/customer-debtor',
  OFFICE_ADDRESS = "office-address",
  CUSTOMER_APPPOINTMENTS='customers/appointments',
  NON_CUSTOMER_OFFICE_ADDRESS='ux/non-customer-office-address',
  UX_SUSPENSE_DEBTORS='ux/suspense-debtors',
  UX_FINDU_USERS='ux/findu-users',
  ARMING_DISARMING_CONTACTS="customer/arming-and-disarming/contacts",

  MAXIMU_ALLOWED_PATROLS = "holiday-instruction-config-details",
  MARKETTING_PREFERENCES='marketing-preferences',
  RADIO_LOST_CONFIG='radio-lost-mapping',
  RADIO_LOST_CONFIG_DETAILS='radio-lost-mapping-details',
  RADIO_LOST_NON_CUSTOMER ='radio-lost-mapping/non-customers',
  RECENT_ACTIVITIES = 'recent-activities',
  CUSTOMER_ADVANCED_SEARCH='customer-advance-search',
  CUSTOMER_ADVANCED_SEARCH_COUNT='customer-advance-search-count',
  FIND_U_USERS_SUBSCRIPTION='findu-users-subscription',
  ADVANCED_SEARCH_RADIO ='customer-radio-search',
  CASUAL_GUARDING_SERVICE_STOCK_CANCEL = 'casual-guarding-service-stock-cancel',
  CUSTOMER_KEYHOLDERS_KEYHOLDERS_PASSWORD = 'customer/keyholders/keyholders-password',
  CUSTOMER_AUDIT_HISTORY = 'audit-log/customer',
}

enum CUSTOMER_COMPONENT {
  CUSTOMER = 'Customers',
  CUSTOMER_MANAGEMENT = 'Customer Management',
  CUSTOMER_TECHNICAL = 'Customers_Technical',
  NON_CUSTOMERS = 'Non Customers',
  COUNTER_SALES = 'Counter Sales',
  TICKETS = 'Tickets',
  CUSTOMER_DASHBOARD = 'Customer Dashboard',
  TECHNICAL = 'TECHNICAL',
  INSTALLATION = 'Installation',
  SERVICE = 'Service',
  DEALER_CALL = 'Dealer Call',
  SPECIAL_PROEJCT = 'Special Project',
  RADIO_REMOVAL = 'Radio Removal',
  INSPECTION = 'Inspection',
  APPOINTMENT_BOOKING = 'Appointment Booking',
  ACTUAL_TIMING = 'Actual Timing',
  ON_HOLD = 'On Hold',
  RETURN_FOR_REPAIR = 'Return for Repair',
  UPSELL_QUOTE = 'Upsell Quote',
  PR_CALL = 'PR Call',
  SAVE_OFFER = 'Save Offer',
  VOID = 'Void',
  REFER_TO_SALES = 'Refer to Sales',
  ESCALAATION = 'Escalation',
  REBOOK = 'Rebook',
  BILL_OF_MATERIALS = 'Bill of Materials',
  VIEW_TRANSFERS = 'View Transfers',
  QUOTE = 'Quote',
  SITE_HAZARD = 'Site Hazard',
  LEAD_HAND_OVER_CERTIFICATE = 'Lead Hand Over Certificate',
  TECHNICAL_ASSISTANT = 'Technical Assistant',
  CALLBACK ='Callback',
  RECURRING_APPOINTMENTS = 'Recurring Appointments',
  CALL_TYPE = 'Call Type',
  ACCEPTANCE = "Acceptance",
  UPGRADE_LEAD_ADD = "Upgrade lead add",
  PROCEED_TO_PAYMENT = "Proceed to Payment",
  SALES= "SALES",
  LEADS ="Leads",
  INSTALLER_CODE = "Installer Code",
  VIDEOFIED_SIM = "Videofied Sim",
  FIDELITY_ADT_SIM = "Fidelity ADT Sim",
  CORRESPONDENCE_LOG = "correspondence log",
  TABS = "tabs",
  CALL_HISTORY = "call history",
  INFO = "info",
  CLASSIFICATIONS = "classifications",
  TICKETING = "ticketing",
  PROFILE_INFORMATION = "profile information",
  SUBSCRIPTION = 'subscription',
  SUPPORT_DOCUMENT = "support document",
  MONITORING_RESPONSE ="monitoring & response",
  SIGNAL_HISTORY = "signal history",
  SIGNAL_SPECIALS = "signal specials",
  DECODERS = "decoders",
  ZONES = 'zones',
  CUSTOMER_PREFERENCE = "customer preference",
  CCTV_POINTS = "cctv points",
  CLIENT_TESTING = "client testing",
  TECHNICIAN_TESTING = "technician testing",
  PATROL_HISTORY = "patrol history",
  ACCESS_INTERCOMS = "access intercoms",
  ERB_EXCLUSION_REQUEST = "erb exclusion request",
  NFC_SITE_TAG_CONFIG = "nfc site tag config",
  CATEGORY = "category",
  ERB_SUMMARY = "erb summary",
  AUDIT = "audit",
  BOUNDRY_ALLOCATION = "boundry allocation",
  MESSAGING_GROUP = "messaging group",
  GUARDING = "guarding",
}



export { CustomerModuleApiSuffixModels ,CUSTOMER_COMPONENT};

